// In this file, the order of the objects makes sense due to the anchor to redirect strategy.
/* eslint-disable perfectionist/sort-objects */

import { FeatureFlagTabs } from '@shared/guards/basic-redirect-to-next-tab.guard';

import { ROUTING_PATH } from '../routingPath';

export const INVESTIGATOR_ROUTES_FEATURE_FLAGS: FeatureFlagTabs = {
  [`${ROUTING_PATH.INVESTIGATOR.INVESTIGATOR_FORECAST.INDEX}/${ROUTING_PATH.INVESTIGATOR.INVESTIGATOR_FORECAST.TABLE}`]:
    'tab_forecast_investigator_forecast',
  [`${ROUTING_PATH.INVESTIGATOR.INVESTIGATOR_FORECAST.INDEX}/${ROUTING_PATH.INVESTIGATOR.INVESTIGATOR_FORECAST.SETTINGS}`]:
    'investigator_forecast_settings',
  [`${ROUTING_PATH.INVESTIGATOR.SITE_COSTS.INDEX}/${ROUTING_PATH.INVESTIGATOR.SITE_COSTS.SITES.INDEX}`]:
    'tab_investigator_sites',
  [`${ROUTING_PATH.INVESTIGATOR.SITE_COSTS.INDEX}/${ROUTING_PATH.INVESTIGATOR.SITE_COSTS.SITE_COST_SUMMARY}`]:
    'tab_trial_settings_patient_protocol',
  [`${ROUTING_PATH.INVESTIGATOR.PROTOCOL_ENTRY.INDEX}/${ROUTING_PATH.INVESTIGATOR.PROTOCOL_ENTRY.PATIENT_GROUPS}`]:
    'tab_patient_groups',
  [ROUTING_PATH.INVESTIGATOR.INVESTIGATOR_DETAIL]: 'tab_forecast_investigator_detail',
  [ROUTING_PATH.INVESTIGATOR.INVESTIGATOR_SUMMARY]: 'tab_investigator_summary',
  [ROUTING_PATH.INVESTIGATOR.INVESTIGATOR_TRANSACTIONS]: 'tab_investigator_transactions',
  [ROUTING_PATH.INVESTIGATOR.PATIENT_TRACKER]: 'nav_patient',
  [ROUTING_PATH.INVESTIGATOR.PAYMENTS_RECONCILIATION]: 'investigator_reconciliation_dashboard',
  [ROUTING_PATH.INVESTIGATOR.PROTOCOL_ENTRY.INDEX]: 'tab_protocol_entry',
};
